import { Link } from "react-router-dom";
import s from "./MainFooterMenu.module.scss";
import { FooterLink } from "../../../../types/MainFooterTypes";

interface Props {
  items: FooterLink[];
}

export const MainFooterMenu: React.FC<Props> = ({ items }) => {
  return (
    <div className={s.menu_items}>
      {items.map((item, i) => (
        <Link target="blank" to={item.link} className={s.menu_item} key={i}>
          {item.title}
        </Link>
      ))}
    </div>
  );
};
